import React, { Component, useEffect } from 'react';
import { Modal, Upload, Popconfirm, message, Divider, Table, Form, Icon, Input, Button, Select, InputNumber, Pagination, Spin, Row, Col, Card, Tooltip } from 'antd';
import client from '../../feathers';
import requireAuth from "../requireAuth";
import Layout from "../layout";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateMode } from '../../actions/actions-recurringitems';
import RecurringFormSingle from "../../components/recurringitems/form";
import RecurringFormMultiple from "../../components/recurringitems/form-multiple";
import axios from 'axios';


const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

const text = 'Are you sure to delete this item?';
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
const PAGESIZE = 20

class EditableCell extends React.Component {
  state = {
    editing: false,
  }

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener('click', this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  }

  handleClickOutside = (e) => {
    const { editing } = this.state;
    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  }

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  }

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;
    return (
      <td ref={node => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              return (
                editing ? (
                  <FormItem style={{ margin: 0 }}>
                    {form.getFieldDecorator(dataIndex, {
                      rules: [{
                        required: true,
                        message: `${title} is required.`,
                      }],
                      initialValue: record[dataIndex],
                    })(
                      <Input
                        ref={node => (this.input = node)}
                        onPressEnter={this.save}
                      />
                    )}
                  </FormItem>
                ) : (
                  <div
                    className="editable-cell-value-wrap"
                    style={{ paddingRight: 24 }}
                    onClick={this.toggleEdit}
                  >
                    {restProps.children}
                  </div>
                )
              );
            }}
          </EditableContext.Consumer>
        ) : restProps.children}
      </td>
    );
  }
}

class RecurringItemsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: [],
      editingKey: '',
      totalPagination: 1,
      loading: true,
      propertyunitsDropdowns: [],
      chargesDropdowns: [],
      refresh: false,
      descriptionFilter: '',
      statusFilter: '',
      chargesFilter: '',
      typingTimeout: 0,
    }

  }
  componentDidUpdate() {

    if (this.state.refresh === true) {
      this.setState({ refresh: false })
      this.componentWillMount()
    }

  }
  componentDidMount() {

  }
  componentWillMount() {
    let companyId = this.props.commons.selectedCompany._id

    client.authenticate()
      .then((res) => {
        return client.service('recurring-items').find({
          query: {
            $limit: 20,
            $populate: 'propertyunitId chargeId',
            propertyId: companyId,
            $sort: {
              propertyunitId: 1
            }
          }
        })
      })
      .then((res) => {
        console.log(res)
        this.setState({
          dataSource: res.data,
          totalPagination: res.total,
          loading: false
        });
      })
      .catch((err) => {
        this.setState({ loading: true });
        console.log(err);
      });
    this.getPropertyunits();
    this.getCharges();
  }

  getPropertyunits() {
    let companyId = this.props.commons.selectedCompany._id
    //generate property unit dropdown
    client.authenticate()
      .then((res) => {
        return client.service('propertyunits').find({
          query: {
            propertyId: companyId,
            $sort: {
              referenceId: 1
              //createdAt: -1
            },
            $limit: 20,
          }
        })
      })
      .then((res) => {

        this.setState({ propertyunitsDropdowns: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCharges() {
    let companyId = this.props.commons.selectedCompany._id
    //generate charges dropdown
    client.authenticate()
      .then((res) => {
        return client.service('charges').find({
          query: {
            propertyId: companyId,
            $sort: {
              code: 1
            }
          }
        })
      })
      .then((res) => {
        this.setState({ chargesDropdowns: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handlePageChange = (page) => {
    let companyId = this.props.commons.selectedCompany._id
    console.log({ page })
    // this.setState({ loading: true });

    let descriptionFilter = this.state.descriptionFilter === '' ? '' : { description: { $regex: this.state.descriptionFilter, $options: 'i' } };
    let statusFilter = this.state.statusFilter === '' ? '' : { status: this.state.statusFilter };
    let chargesFilter = this.state.chargesFilter === '' ? '' : { chargeId: this.state.chargesFilter };
    let collection = { ...descriptionFilter, ...statusFilter, ...chargesFilter };

    this.props.form.validateFields((err, values) => {
      client.authenticate()
        .then((res) => {
          return client.service('recurring-items').find({
            query: {
              ...values,
              ...collection,
              $populate: 'propertyunitId chargeId',
              propertyId: companyId,
              $limit: PAGESIZE,
              $skip: page.current * PAGESIZE,
              $sort: {
                propertyunitId: 1,
              }
            }
          })
        })
        .then((res) => {
          console.log('done')
          this.setState({
            totalPagination: res.total,
            dataSource: res.data,
            loading: false
          });
        })
        .catch((err) => {
          this.setState({ loading: false });
          console.log(err);
        })
    })
  }

  handleDelete = (_id) => {

    client.service('recurring-items').remove(_id)
      .then((res) => {
        message.success('Deleted');
      })
      .catch((err) => {
        alert(err);
      })

    const dataSource = [...this.state.dataSource];
    this.setState({ dataSource: dataSource.filter(item => item._id !== _id) });
  }

  handleAdd = () => {
    const { count, dataSource } = this.state;
    const newData = {
      key: count,
      name: `Edward King ${count}`,
      age: 32,
      address: `London, Park Lane no. ${count}`,
    };
    this.setState({
      dataSource: [...dataSource, newData],
      count: count + 1,
    });
  }

  handleSave = (row) => {

    client.service('recurring-items').patch(row._id,
      {
        amount: row.amount,
        status: row.status
      }
    )
      .then((res) => {

        message.success(`Record Updated`);
      })
      .catch((err) => {
        console.log(err);
      })

    const newData = [...this.state.dataSource];
    const index = newData.findIndex(item => row._id === item._id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    this.setState({ dataSource: newData });
  }

  formatAmt(amt) {
    let integer = parseFloat(amt);
    return integer > 0 ? integer.toFixed(2) : 0.00;
  }

  handleSearch = (e) => {
    let companyId = this.props.commons.selectedCompany._id

    try {
      e.preventDefault();
    }
    catch (err) { };

    if (e == "ShowAll") {
      e = '';
    }
    let filerAccountName = e === '' ? '' : { propertyunitId: e };
    let descriptionFilter = this.state.descriptionFilter === '' ? '' : { description: { $regex: this.state.descriptionFilter, $options: 'i' } };
    let statusFilter = this.state.statusFilter === '' ? '' : { status: this.state.statusFilter };
    let chargesFilter = this.state.chargesFilter === '' ? '' : { chargeId: this.state.chargesFilter };
    let collection = { ...filerAccountName, ...descriptionFilter, ...statusFilter, ...chargesFilter };

    this.props.form.validateFields((err, values) => {
      client.authenticate()
        .then((res) => {

          return client.service('recurring-items').find({
            query: {
              //  ...values,
              //propertyunitId:e,
              ...collection,
              $populate: 'propertyunitId chargeId',
              propertyId: companyId,
              $sort: {
                propertyunitId: 1
              },
            }
          })
        })
        .then((res) => {
          this.setState({
            dataSource: res.data,
            totalPagination: res.total,
          });
        })
        .catch((err) => {
          console.log(err);
        });

    });
  }

  handleDescriptionFilter = (e) => {
    clearTimeout(this.state.typingTimeout);
    this.setState({
      descriptionFilter: e.target.value,
      typingTimeout: setTimeout(() => {
        this.handleSearch();
      }, 500)
    });
  }

  handleStatusFilter = (value) => {
    this.setState({
      statusFilter: value
    }, () => {
      this.handleSearch();
    });
  }

  handleChargesFilter = (value) => {
    this.setState({
      chargesFilter: value
    }, () => {
      this.handleSearch();
    });
  }

  handleSearchPropertyunit = (value) => {
    let companyId = this.props.commons.selectedCompany._id
    //generate charges dropdown


    this.setState({ fetching: true });
    client.authenticate()
      .then((res) => {
        return client.service('propertyunits').find({
          query: {
            propertyId: companyId,
            orRegex: {
              referenceId: value
            },
            $sort: {
              referenceId: 1
            }

          }
        })
      })
      .then((res) => {

        this.setState({
          propertyunitsDropdowns: res.data,
          fetching: false,
        });
      })
      .catch((err) => {
        this.setState({ fetching: false });
        console.log(err);
      });
  }

  handleRecalculate = () => {
    let companyId = this.props.commons.selectedCompany._id

    client.authenticate()
      .then((res) => {
        return axios.get(`${client.io.io.uri}recalculate-recurring-items`, {
          params: {
            propertyId: companyId,
          },
          headers: {
            'Authorization': client.settings.storage.storage['feathers-jwt']
          }
        })
      })
      .then((res) => {
        this.setState({
          refresh: true,
        });
        message.success('Recalculating in progress.It\'s might take few minute to complete.')
        // console.log(res)
      })
      .catch((err) => {
        this.setState({
          refresh: true,
        });
        console.log(err);
      });
  }
  renderSearching() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form
        className="ant-advanced-search-form"
        onSubmit={this.handleSearch}
      >
        <Row gutter={24} style={{ display: 'block' }}>
          <Col span={8}>
            <Form.Item label='Unit Number'>
              {getFieldDecorator(`propertyunitId`, {
                rules: [{
                  required: false,
                  message: 'Unit Number!',
                }],
              })(
                <Select
                  showSearch
                  // value={value}
                  placeholder="Select Units"
                  notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  onSearch={this.handleSearchPropertyunit}
                  // onChange={this.handleSearchPropertyunit}
                  style={{ width: '100%' }}
                >
                  {this.state.propertyunitsDropdowns.map(d => <Option key={d._id}>{d.referenceId}</Option>)}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Button type="primary" htmlType="submit" style={{ float: 'right' }} >Search</Button>
        </Row>
      </Form>
    )
  }

  render() {
    const { visible, onCancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const dataSource = this.state.dataSource;
    const loading = this.state.loading;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = [
      {
        title: (
          <Row gutter={8}>
            <Row><Col span={24}>Property Unit No.</Col></Row>
            <Row><Col span={24}>
              <Select
                showSearch
                placeholder="Select Units"
                notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
                filterOption={false}
                showArrow={false}
                onSearch={this.handleSearchPropertyunit}
                onChange={this.handleSearch}
                style={{ width: '100%' }}
              >
                <Option key='ShowAll'>All</Option>
                {this.state.propertyunitsDropdowns.map(d => <Option key={d._id}>{d.referenceId}</Option>)}
              </Select>
            </Col></Row>
          </Row>
        ),
        dataIndex: 'propertyunitId.referenceId',
        width: '15%',
        editable: false,
      },
      {
        title: 'Size',
        dataIndex: 'propertyunitId.size',
        width: '6%',
        editable: false,
      },
      {
        title: 'Extra Size',
        dataIndex: 'propertyunitId.extraSize',
        width: '7%',
        editable: false,
      },
      {
        title: (
          <div>
            <div style={{ marginBottom: 8 }}>Charges</div>
            <Select
              placeholder="Filter by charges"
              value={this.state.chargesFilter}
              onChange={this.handleChargesFilter}
              style={{ width: '100%', minWidth: '200px' }}
              size="small"
              allowClear
              dropdownStyle={{ minWidth: '300px' }}
              showSearch
              filterOption={(input, option) => {
                const charge = this.state.chargesDropdowns.find(c => c._id === option.key);
                if (!charge) return false;
                const searchText = `${charge.code} ${charge.description}`.toLowerCase();
                return searchText.indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {this.state.chargesDropdowns.map(dropdown => (
                <Option key={dropdown._id} value={dropdown._id} title={`${dropdown.code} - ${dropdown.description}`}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                      {dropdown.code}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666' }}>
                      {dropdown.description}
                    </div>
                  </div>
                </Option>
              ))}
            </Select>
          </div>
        ),
        dataIndex: 'chargeId.description',
        width: '20%',
        editable: false,
        render: (text, record) => {
          if (!record.chargeId) {
            return (
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '12px' }}>N/A</div>
                <div style={{ fontSize: '11px', color: '#666' }}>No charge info</div>
              </div>
            );
          }

          const charge = record.chargeId;
          const tooltipContent = (
            <div style={{ maxWidth: '350px' }}>
              <div style={{ marginBottom: '8px' }}>
                <strong>Code:</strong> {charge.code}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Description:</strong> {charge.description}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Account No:</strong> {charge.accountNo || 'N/A'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Late Charge:</strong> {charge.lateCharge || 'NO'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Type:</strong> {charge.chargeType || 'N/A'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Amount:</strong> {charge.amount ? this.formatAmt(charge.amount) : 'N/A'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Percentage:</strong> {charge.percentage ? `${charge.percentage}%` : 'N/A'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Status:</strong> {charge.status || 'N/A'}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Apply On Month:</strong> {charge.applyOnMonth && charge.applyOnMonth.length > 0 ? charge.applyOnMonth.join(', ') : 'All'}
              </div>
              {charge.specialCode && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Special Code:</strong> {charge.specialCode}
                </div>
              )}
              {charge.ledgerAccountId && (
                <div>
                  <strong>Ledger Account ID:</strong> {charge.ledgerAccountId}
                </div>
              )}
            </div>
          );

          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                  {charge.code}
                </div>
                <div style={{ fontSize: '11px', color: '#666' }}>
                  {charge.description}
                </div>
              </div>
              <Tooltip title={tooltipContent} placement="right">
                <Icon
                  type="info-circle"
                  style={{
                    marginLeft: '8px',
                    color: '#1890ff',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                />
              </Tooltip>
            </div>
          );
        },
      },
      {
        title: (
          <div>
            <div style={{ marginBottom: 8 }}>Description</div>
            <Input
              placeholder="Filter by description"
              value={this.state.descriptionFilter}
              onChange={this.handleDescriptionFilter}
              style={{ width: '100%', minWidth: '150px' }}
              size="small"
            />
          </div>
        ),
        dataIndex: 'description',
        width: '20%',
        editable: false,
      },
      {
        title: (
          <div>
            <div style={{ marginBottom: 8 }}>Status</div>
            <Select
              placeholder="Filter by status"
              value={this.state.statusFilter}
              onChange={this.handleStatusFilter}
              style={{ width: '100%', minWidth: '120px' }}
              allowClear
              size="small"
            >
              <Option value="ACTIVE">ACTIVE</Option>
              <Option value="INACTIVE">INACTIVE</Option>
            </Select>
          </div>
        ),
        dataIndex: 'status',
        width: '12%',
        editable: true,
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        width: '12%',
        editable: true,
        align: 'right',
        render: (text, record) => (
          <span>{this.formatAmt(record.amount)}</span>
        ),
      }, {
        title: 'operation',
        dataIndex: 'operation',
        render: (text, record) => (
          this.state.dataSource.length >= 1
            ? (
              <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record._id)}>
                <a href="javascript:;">Delete</a>
              </Popconfirm>
            ) : null
        ),
      }
    ];

    const columns2 = columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <Layout>
        <Card
          loading={loading}
          title={'RECURRING ITEMS'}
          extra={[
            <Row gutter={16}>
              <Col span={8}>
                <RecurringFormSingle />
              </Col>
              <Col span={8}>
                <RecurringFormMultiple />
              </Col>
              <Col span={8}>
                <Button style={{ "marginRight": "10px" }} type="primary" onClick={this.handleRecalculate} >Re-Calculate</Button>
              </Col>
            </Row>
          ]}
        >
          {/*  {this.renderSearching()} */}
          {/* <RecurringFormMultiple /> */}
          {/*<Table dataSource={this.state.ledgerAccounts} columns={columns} rowKey="_id" />*/}
          <Table
            components={components}
            rowClassName={() => 'editable-row'}
            rowKey="_id"
            bordered
            dataSource={dataSource}
            columns={columns2}
            size={'small'}
            pagination={{
              // defaultCurrent: '1',
              total: this.state.totalPagination,
              pageSize: 20,
            }}
            onChange={this.handlePageChange}
          />
        </Card>
      </Layout>

    )
  }
}


function mapStateToProps(state) {
  return {
    recurringitems: state.recurringitems,
    commons: state.commons
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateMode: updateMode
  }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(RecurringItemsIndex)));
